import { render, staticRenderFns } from "./SeeBindGoods.vue?vue&type=template&id=7bc6dceb&scoped=true&"
import script from "./SeeBindGoods.vue?vue&type=script&lang=ts&"
export * from "./SeeBindGoods.vue?vue&type=script&lang=ts&"
import style0 from "./SeeBindGoods.vue?vue&type=style&index=0&id=7bc6dceb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc6dceb",
  null
  
)

export default component.exports